import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import ReactHtmlParser from "react-html-parser";

class ListElement extends PureComponent {
  render() {
    const text = this.getText();

    return (
      <div>
        <h5 className="wc-gifitingdetails-listsubtitle">{text.title}</h5>
        {text.subpoints.map(object => (
          <ul className="wc-giftingdetails-list">
            <li className="wc-giftingdetails-listelement">
              {ReactHtmlParser(object)}
            </li>
          </ul>
        ))}
      </div>
    );
  }

  getText() {
    return this.props.data;
  }
}

ListElement.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subpoints: PropTypes.array,
    }),
  ).isRequired,
};

export default ListElement;
